<script setup lang="ts">
    import ProgressNav from "@songfinch/customer/components/song_builder/ProgressNav.vue";
    import onPageLoaded from "@songfinch/customer/composables/onPageLoaded";
    import analyticsEvent from "@songfinch/shared/helpers/analyticsEvent";
    import vFocusTrap from "@songfinch/customer/directives/focus_trap";
    import vScrollTopOnRouteChange from "@songfinch/shared/directives/vScrollTopOnRouteChange";
    import {loadSingleProduct} from "@songfinch/customer/composables/useProduct";
    import {useSongBuilderStore} from "@songfinch/customer/store_v2/useSongBuilderStore";

    const storeSongBuilder = useSongBuilderStore();

    onPageLoaded(async () => {
        const product = await loadSingleProduct({productSlug: storeSongBuilder.getSongProduct});
        analyticsEvent("_sf_viewcontent", {
            ecommerce: {
                content_id: product.sku,
                content_type: "product",
                content_name: product.title,
                price: product.price / 100,
                currency: "USD",
                detail: {
                    actionField: {},    // 'detail' actions have an optional list property.
                    products: [{
                        name: product.title,         // Name or ID is required.
                        id: product.sku,
                        price: product.price / 100,
                        brand: "",
                        category: "",
                        variant: ""
                    }]
                }
            }
        });
    });
</script>

<template>
    <div v-focus-trap v-scroll-top-on-route-change="$router" class="page songBuilderPage" :class="$route.name + 'Page'">
        <div class="songBuilderPageContent">
            <ProgressNav/>
            <router-view v-slot="{Component}">
                <transition name="custFade" duration="500">
                    <component :is="Component" :key="$route.path"/>
                </transition>
            </router-view>
        </div>
    </div>
</template>

<style>
    @import "@songfinch/customer/stylesheets/includes/pages/_build-song.pcss";
</style>
